import React from "react";

import { Button } from "./styles";

interface IconButtonProps {
    onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
    label: string;
    // large — 44px, размер кнопки-действия в шапке и минимальная зона нажатия на тач-экране.
    size?: "large" | "medium" | "small";
    // outlined — та же рамка и фон, что у обычной кнопки кита: нужен, когда иконка стоит
    // в одном ряду с текстовыми кнопками и должна читаться как равная им.
    variant?: "plain" | "outlined";
    tone?: "default" | "danger";
    disabled?: boolean;
    className?: string;
    children: React.ReactNode;
}

// Кнопка-иконка («⋯» на плитке, действия в строке списка, свёрнутые действия шапки).
// Подпись обязательна — уходит в aria-label, иначе у кнопки нет доступного имени.
// Нативный title не ставим: браузерная подсказка большая и в плотных местах перекрывает
// соседний контент.
export const IconButton = ({
    onClick,
    label,
    size = "medium",
    variant = "plain",
    tone = "default",
    disabled,
    className,
    children,
}: IconButtonProps) => (
    <Button
        type="button"
        aria-label={label}
        disabled={disabled}
        className={className}
        $size={size}
        $variant={variant}
        $tone={tone}
        onClick={onClick}
    >
        {children}
    </Button>
);
